import { Button, Form, Input, InputNumber } from "antd";
import BackTitle from "../common/BackTitle";
import FormPage from "../common/FormPage";
import { useEffect } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router-dom";
import { requiredField } from "../common/common";

export default function () {
    const [form] = Form.useForm();
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axiosInstance.get(`/employee/${id}/hourRate`).then(({ data }) => form.setFieldsValue(data));
    });
    const onFinish = (data) => {
        axiosInstance.put(`/employee/${id}/hourRate`, data).then(() => {
            navigate(-1);
        });
    };

    return (
        <>
            <FormPage title="Modifica paga oraria" form={form} onFinish={onFinish}>
                <Form.Item label="€/ora" name="hourRate" rules={[requiredField]} hasFeedback>
                    <InputNumber
                        precision={2}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        decimalSeparator=","
                    />
                </Form.Item>
                <Form.Item style={{ textAlign: "end" }}>
                    <Button htmlType="submit" type="primary">
                        Salva
                    </Button>
                </Form.Item>
            </FormPage>
        </>
    );
}
